module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"toast-item":{"close":"Luk"}},"de":{"version":1,"toast-item":{"close":"Schließen"}},"en":{"toast-item":{"close":"Close"}},"fr":{"toast-item":{"close":"Fermer"}},"nl":{"toast-item":{"close":"Sluiten"}},"pl":{"toast-item":{"close":"Zamknij"}}}')
  delete Component.options._Ctor
}
